import Swal from 'sweetalert2'

import { lang } from '../../assets/lang'
import {
  hasDuplicates,
  uniqueId as getUniqueId, 
  sweetAlertCommonParams,
  getSelectOptionsFromArrayOfObjects,
} from '../../utils/functions'

import { 
  conditionSystemFieldVariables,
  conditionSystemFieldOperators 
} from '../../data'

// eslint-disable-next-line
export const conditionModal = async (oldData, node) => {

  const commonParams = sweetAlertCommonParams(node, '25rem')  

  return await Swal.fire({
    ...commonParams,
    title: lang.condition_modal_title,
    html: getHtmlForModal(oldData),

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })
      
      getLabelViaAjax(function(response) {
        const html = getSelectOptions(response)
        window.xitFlowBuilderConditionLabels = html

        if (oldData.system_field_variable) {
          oldData.system_field_variable.forEach((val, idx) => {
            if ('contact_group_id' === val) {
              const element = '#condition-system-field-contact-group-id-group-' + idx + ' .system-field-contact-group-id'
              $(element).html(html)
              $(element).val(oldData.system_field_contact_group_id_selected_values).trigger('change')
            }
          })
        }
      })

      getCustomFieldVariableViaAjax(function(response) {
        const html = response.custom_field_variable_dropdown
        window.xitFlowBuilderCustomFieldVariableDropdown = html

        if (oldData.custom_field_variable) {
          oldData.custom_field_variable.forEach((val, idx) => {
            if (0 === idx) {
              window.xitFlowBuilderCustomFieldVariableDefaultValue = val
            }
  
            const element = '#condition-custom-field-variable-group-' + idx + ' .custom-field-variable'
            $(element).html(html)
            $(element).val(val).trigger('change')
          })
        } else {
          const element = '#condition-custom-field-variable-group-0 .custom-field-variable'
          $(element).html(html)
        }
      })

      toggleFormTagForSystemFieldVariable()
      toggleFormTagForSystemFieldOperator()
      setRestrictedOperatorIfSystemFieldVariable()
      setRestrictedOperatorIfCustomFieldVariable()

      $('#system-field-row-add').on('click', function() {
        const uniqueId = getUniqueId()
        const systemFieldHtml = getSystemFieldHtml(uniqueId)
        $('#system-field-wrapper').append(systemFieldHtml)

        $('.select2').select2({ 
          width: '100%',
          dropdownParent: $('#swal2-content')
        })

        return false
      })

      $('#custom-field-row-add').on('click', function() {
        const uniqueId = getUniqueId()
        const customFieldHtml = getCustomFieldHtml(uniqueId)
        $('.custom-field-wrapper').append(customFieldHtml)
        
        const element = $('#condition-custom-field-variable-group-' + uniqueId + ' .custom-field-variable')
        element.html(window.xitFlowBuilderCustomFieldVariableDropdown)

        $('.select2').select2({ 
          width: '100%',
          dropdownParent: $('#swal2-content')
        })

        return false
      })

      $(document).on('click', '.field-row-remove', function() {
        $(this).parent().parent().remove()
      })
    },

    preConfirm: () => {
      if (! Swal.isLoading()) {
        Swal.showLoading()
      }

      const all_match = $('#condition-match-all').prop('checked')
      const any_match = $('#condition-match-anything').prop('checked')

      const system_field_variable = $('.system-field-variable').map((index, element) => element.value).get() // eslint-disable-line
      const system_field_variable_selected_texts = $('.system-field-variable option:selected').map((index, element) => element.label).get() // eslint-disable-line

      const system_field_operator = $('.system-field-operator').map((index, element) => element.value).get() // eslint-disable-line
      const system_field_operator_selected_texts = $('.system-field-operator option:selected').map((index, element) => element.label).get() // eslint-disable-line
      
      const system_field_variable_value = $('.system-field-variable-value').map((index, element) => element.value).get() // eslint-disable-line
      
      const system_field_gender = $('.system-field-gender').map((index, element) => element.value).get() // eslint-disable-line
      const system_field_gender_selected_texts = $('.system-field-gender option:selected').map((index, element) => element.label).get() // eslint-disable-line
      
      const system_field_contact_group_id = $('.system-field-contact-group-id').map((index, element) => element.value).get() // eslint-disable-line
      const system_field_contact_group_id_selected_values = $('.system-field-contact-group-id option:selected').map((index, element) => element.value).get() // eslint-disable-line
      const system_field_contact_group_id_selected_texts = $('.system-field-contact-group-id option:selected').map((index, element) => element.label).get() // eslint-disable-line
      
      const custom_field_variable = $('.custom-field-variable').map((index, element) => element.value).get() // eslint-disable-line
      const custom_field_variable_selected_values = $('.custom-field-variable option:selected').map((index, element) => element.value).get() // eslint-disable-line
      const custom_field_variable_selected_texts = $('.custom-field-variable option:selected').map((index, element) => element.label).get() // eslint-disable-line
      
      const custom_field_operator = $('.custom-field-operator').map((index, element) => element.value).get() // eslint-disable-line
      const custom_field_operator_selected_texts = $('.custom-field-operator option:selected').map((index, element) => element.label).get() // eslint-disable-line
      
      const custom_field_variable_value = $('.custom-field-variable-value').map((index, element) => element.value).get() // eslint-disable-line

      if (system_field_variable.filter(Boolean).length > 0) {
        if (hasDuplicates(system_field_variable)) {
          Swal.showValidationMessage(lang.condition_modal_msg_duplicates_system_field)
          Swal.hideLoading()
  
          return false
        }

        system_field_variable.forEach((val, idx) => {
          if ('gender' === val) {
            if ('equal' !== system_field_operator[idx]) {
              Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_required_equal_operator)
              Swal.hideLoading()
              
              return false
            }
    
            if (! system_field_gender[idx]) {
              Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_gender_type)
              Swal.hideLoading()

              return false
            }
          } else if ('contact_group_id' === val) {
            if (! system_field_contact_group_id[idx]) {
              Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_label)
              Swal.hideLoading()

              return false
            }
          } else {
            if ('has_value' !== system_field_operator[idx] && ! system_field_variable_value[idx]) {
              Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_variable_value_system_field)
              Swal.hideLoading()
  
              return false
            }
          }

          if (! system_field_operator[idx]) {
            Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_operator_system_field)
            Swal.hideLoading()

            return false
          }
        })
      }

      if (custom_field_variable_selected_values.filter(Boolean).length > 0) {
        if (hasDuplicates(custom_field_variable)) {
          Swal.showValidationMessage(lang.duplicates_custom_field)
          Swal.hideLoading()

          return false
        }

        custom_field_variable.forEach((val, idx) => {
          if (! val) {
            Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_duplicates_custom_field)
            Swal.hideLoading()

            return false
          }

          if (val && ! custom_field_operator[idx]) {
            Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_operator_custom_field)
            Swal.hideLoading()

            return false
          }

          if (val && ('has_value' !== custom_field_operator[idx]) && ! custom_field_variable_value[idx]) {
            Swal.showValidationMessage('#' + (idx + 1) + ' ' + lang.condition_modal_msg_variable_value_custom_field)
            Swal.hideLoading()

            return false
          }
        })
      }

      if (Swal.isLoading()) {
        Swal.hideLoading()
      }

      return {
        all_match,
        any_match,

        system_field_variable,
        system_field_variable_selected_texts,
        
        system_field_operator,
        system_field_operator_selected_texts,

        system_field_variable_value,

        system_field_gender,
        system_field_gender_selected_texts,

        system_field_contact_group_id,
        system_field_contact_group_id_selected_values,
        system_field_contact_group_id_selected_texts,

        custom_field_variable,
        custom_field_variable_selected_values,
        custom_field_variable_selected_texts,

        custom_field_operator,
        custom_field_operator_selected_texts,

        custom_field_variable_value,
      }
    },    
  })
}

const toggleFormTagForSystemFieldVariable = () => {
  $(document).on('change', '.system-field-variable', function() {
    const val = $(this).val()
    const ancestor = $(this).parent().parent().parent()

    if ('gender' === val) {
      $(ancestor).find('div[id^="condition-system-field-contact-group-id-group-"]').removeClass('d-block').addClass('d-none')
      $(ancestor).find('div[id^="condition-system-field-variable-value-group-"]').removeClass('d-block').addClass('d-none')
      $(ancestor).find('div[id^="condition-system-field-gender-group-"]').removeClass('d-none').addClass('d-block')
      $(ancestor).find('.system-field-operator').val('equal').trigger('change')
    } else if ('contact_group_id' === val) {
      $(ancestor).find('div[id^="condition-system-field-variable-value-group-"]').removeClass('d-block').addClass('d-none')
      $(ancestor).find('div[id^="condition-system-field-gender-group-"]').removeClass('d-block').addClass('d-none')
      $(ancestor).find('div[id^="condition-system-field-contact-group-id-group-"]').removeClass('d-none').addClass('d-block')
      
      // Populate select options
      const element = $(ancestor).find('.system-field-contact-group-id')
      $(element).html(window.xitFlowBuilderConditionLabels)
    } else {
      $(ancestor).find('div[id^="condition-system-field-contact-group-id-group-"]').removeClass('d-block').addClass('d-none')
      $(ancestor).find('div[id^="condition-system-field-gender-group-"]').removeClass('d-block').addClass('d-none')
      
      const operatorSelected = $(ancestor).find('.system-field-operator').val()
      if ('has_value' !== operatorSelected) {
        $(ancestor).find('div[id^="condition-system-field-variable-value-group-"]').removeClass('d-none').addClass('d-block')
      }
    }
  });

  return false
}

const toggleFormTagForSystemFieldOperator = () => {
  $(document).on('change', '.system-field-operator', function() {
    const val = $(this).val()
    const ancestor = $(this).parent().parent().parent()
    const variableSelected = $(ancestor).find('.system-field-variable').val()
    
    if ('gender' === variableSelected) {
      if ('equal' !== val) {
        $(this).val('equal').trigger('change')
      }
    } else if ('contact_group_id' === variableSelected) {
      if ('contains' !== val) {
        $(this).val('contains').trigger('change')
      }
    }

    const variableValues = ['gender', 'contact_group_id']

    if ('has_value' === val && ! (variableValues.indexOf(variableSelected) > -1)) {
      $(ancestor).find('div[id^="condition-system-field-variable-value-group-"]').removeClass('d-block').addClass('d-none')
    } else if ('has_value' !== val && ! (variableValues.indexOf(variableSelected) > -1)) {
      $(ancestor).find('div[id^="condition-system-field-variable-value-group-"]').removeClass('d-none')
    }
  })

  return false
}

const setRestrictedOperatorIfSystemFieldVariable = () => {
  $(document).on('change', '.system-field-variable', function() {
    const val = $(this).val()
    const ancestor = $(this).parent().parent().parent()
    const selectedOperator = $(ancestor).find('.system-field-operator').val()
    if ('gender' === val) {
      if ('equal' !== selectedOperator) {
        $(ancestor).find('.system-field-operator').val('equal').trigger('change')
      }
    } else if ('contact_group_id' === val) {
      if ('contains' !== selectedOperator) {
        $(ancestor).find('.system-field-operator').val('contains').trigger('change')
      }
    }
  })
}

const setRestrictedOperatorIfCustomFieldVariable = () => {
  $(document).on('change', '.custom-field-operator', function() {
    const val = $(this).val()
    const ancestor = $(this).parent().parent().parent()
    
    if ('has_value' === val) {
      $(ancestor).find('div[id^="condition-custom-field-variable-value-group-"]').removeClass('d-block').addClass('d-none')
    } else {
      $(ancestor).find('div[id^="condition-custom-field-variable-value-group-"]').removeClass('d-none').addClass('d-block')
    }
  });

  return false
}

const getSystemFieldHtml = (uniqueId) => {
  let html = '' +
    '<div class="row position-relative">' +
      '<div id="condition-system-field-variable-group-' + uniqueId + '" class="col-12 col-md-4">' +
        '<div class="select2-width-200 form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_variable + '</label>' +
          '<select class="system-field-variable form-control select2">' +
            '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
            getSelectOptions(conditionSystemFieldVariables) +
          '</select>' +
        '</div>' +
      '</div>' +

      '<div id="condition-system-field-operator-group-' + uniqueId + '" class="col-12 col-md-4">' +
        '<div class="form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_operator + '</label>' +
          '<select class="system-field-operator form-control select2">' +
            '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
            getSelectOptions(conditionSystemFieldOperators) +
          '</select>' +
        '</div>' +
      '</div>' +

      '<div id="condition-system-field-variable-value-group-' + uniqueId + '" class="col-12 col-md-4">' +
        '<div class="form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_value + '</label>' +
          '<input class="system-field-variable-value form-control" type="text">' +
        '</div>' +
      '</div>' +

      '<div id="condition-system-field-gender-group-' + uniqueId + '" class="col-12 col-md-4 d-none">' +
        '<div class="form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_gender + '</label>' +
          '<select class="system-field-gender form-control select2">' +
            '<option value="">' + lang.condition_html_title_select + '</option>' +
            '<option value="male">' + lang.condition_html_gender_male + '</option>' +
            '<option value="female">' + lang.condition_html_gender_female + '</option>' +
          '</select>' +
        '</div>' +
      '</div>' +

      '<div id="condition-system-field-contact-group-id-group-' + uniqueId + '" class="col-12 col-md-4 d-none">' +
        '<div class="form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_contact_group_id + '</label>' +
          '<select class="system-field-contact-group-id form-control select2"></select>' +
        '</div>' +
      '</div>' +
      '<div class="field-remove-wrapper"><i class="fas fa-minus-circle system-field-row-icon field-row-remove"></i></div>' +  
    '</div><!-- end .row -->'

  return html
}

const getCustomFieldHtml = (uniqueId) => {
  let html = '' +
    '<div class="row position-relative">' +
      '<div id="condition-custom-field-variable-group-' + uniqueId + '" class="col-12 col-md-4">' +
        '<div class="select2-width-200 form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_variable + '</label>' +
          '<select class="custom-field-variable form-control select2">' +
            '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
          '</select>' +
        '</div>' +
      '</div>' +

      '<div id="condition-custom-field-operator-group-' + uniqueId + '" class="col-12 col-md-4">' +
        '<div class="form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_operator + '</label>' +
          '<select class="custom-field-operator form-control select2">' +
            '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
            getSelectOptions(conditionSystemFieldOperators) +
          '</select>' +
        '</div>' +
      '</div>' +

      '<div id="condition-custom-field-variable-value-group-' + uniqueId + '" class="col-12 col-md-4">' +
        '<div class="form-group text-left mt-2">' + 
          '<label>' + lang.condition_html_label_value + '</label>' +
          '<input class="custom-field-variable-value form-control" type="text">' +
        '</div>' +
      '</div>' +
      '<div class="field-remove-wrapper"><i class="fas fa-minus-circle custom-field-row-icon field-row-remove"></i></div>' +
    '</div><!-- end .row -->'

  return html
}

const getHtmlForModal = (oldData) => {
  
  const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
  let system_field_html = ''

  const isCheckedAllMatch = (true === oldData.all_match) 
    ? 'checked'
    : ((true !== oldData.any_match) 
      ? 'checked'
      : '')

  const isCheckedAnyMatch = (true === oldData.any_match) ? 'checked' : ''

  system_field_html +=       
    '<div class="row mt-4">' +
      '<div class="form-group text-left col-12 col-sm-6">' +
        '<div class="control-label">'+ lang.condition_html_label_all_match +'</div>' +
        '<label class="mt-2">' +
          '<input id="condition-match-all" class="custom-switch-input" value="All" type="radio" name="match_type" ' + isCheckedAllMatch + '>' +
          '<span class="custom-switch-indicator"></span>' +
        '</label>' +
      '</div>' +

      '<div class="form-group text-left col-12 col-sm-6">' +
        '<div class="control-label">' + lang.condition_html_label_any_match + '</div>' +
        '<label class="mt-2">' +
          '<input id="condition-match-anything" class="custom-switch-input" value="Any" type="radio" name="match_type" ' + isCheckedAnyMatch + '>' +
          '<span class="custom-switch-indicator"></span>' +
        '</label>' +
      '</div>' +
    '</div>'

  if (! instagram_bot_addon) {  
    if (oldData.system_field_variable && oldData.system_field_variable.length > 0) {
      system_field_html +=
        '<div id="system-field-wrapper" class="system-field-wrapper mt-4">' +
          '<div class="d-flex justify-content-start small pl-0">' +
            '<div>' + lang.condition_html_label_system_field + '</div> ' + 
            '<div id="system-field-row-add" class="pl-2"><i class="fas fa-plus-circle text-primary system-field-row-icon"></i></div>' +
          '</div>'
      
      oldData.system_field_variable.forEach((val, idx) => {
        const isVariableValueHideable = ('gender' === val || 'contact_group_id' === val || 'has_value' === oldData.system_field_operator[idx])
        
        system_field_html += '' +
          '<div class="row position-relative">' +
            '<div id="condition-system-field-variable-group-' + idx + '" class="col-12 col-md-4">' +
              '<div class="select2-width-200 form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_variable + '</label>' +
                '<select class="system-field-variable form-control select2">' +
                  '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
                  getSelectOptionsFromArrayOfObjects(conditionSystemFieldVariables, val) +
                '</select>' +
              '</div>' +
            '</div>' +

            '<div id="condition-system-field-operator-group-' + idx + '" class="col-12 col-md-4">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_operator + '</label>' +
                '<select class="system-field-operator form-control select2">' +
                  '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
                  getSelectOptionsFromArrayOfObjects(conditionSystemFieldOperators, oldData.system_field_operator[idx]) +
                '</select>' +
              '</div>' +
            '</div>' +

            '<div id="condition-system-field-gender-group-' + idx + '" class="col-12 col-md-4 ' + ('gender' === val ? 'd-block' : 'd-none') + '">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_gender + '</label>' +
                '<select class="system-field-gender form-control select2">' +
                  '<option value="">' + lang.condition_html_title_select + '</option>' +
                  '<option value="male" ' + ('male' === oldData.system_field_gender[idx] ? 'selected' : null) + '>' + lang.condition_html_gender_male + '</option>' +
                  '<option value="female" ' + ('female' === oldData.system_field_gender[idx] ? 'selected' : null) + '>' + lang.condition_html_gender_female + '</option>' +
                '</select>' +
              '</div>' +
            '</div>'+

            '<div id="condition-system-field-contact-group-id-group-' + idx + '" class="col-12 col-md-4 ' + ('contact_group_id' === val ? 'd-block' : 'd-none') + '">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_contact_group_id + '</label>' +
                '<select class="system-field-contact-group-id form-control select2"></select>' +
              '</div>' +
            '</div>' +

            '<div id="condition-system-field-variable-value-group-' + idx + '" class="col-12 col-md-4 ' + (isVariableValueHideable ? 'd-none' : 'd-block') + '">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_value + '</label>' +
                '<input class="system-field-variable-value form-control" type="text" value="' + oldData.system_field_variable_value[idx] + '">' +
              '</div>' +
            '</div>' +
            '<div class="field-remove-wrapper"><i class="fas fa-minus-circle system-field-row-icon field-row-remove ' + (0 === idx ? 'd-none' : 'd-inline') + '"></i></div>' +
          '</div><!-- ends .row -->'
      })
      system_field_html += '</div><!-- ends .system-field-wrapper -->'
    } else {
      system_field_html +=
        '<div id="system-field-wrapper" class="system-field-wrapper mt-4">' +
          '<div class="d-flex justify-content-start small pt-0">' +
            '<div>' + lang.condition_html_label_system_field + '</div> ' + 
            '<div id="system-field-row-add" class="pl-2"><i class="fas fa-plus-circle text-primary system-field-row-icon"></i></div>' +
          '</div>' +
          
          '<div class="row">' +
            '<div id="condition-system-field-variable-group-0" class="col-12 col-md-4">' +
              '<div class="select2-width-200 form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_variable + '</label>' +
                '<select class="system-field-variable form-control select2">' +
                  '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
                  getSelectOptionsFromArrayOfObjects(conditionSystemFieldVariables) +
                '</select>' +
              '</div>' +
            '</div>' +

            '<div id="condition-system-field-operator-group-0" class="col-12 col-md-4">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_operator + '</label>' +
                '<select class="system-field-operator form-control select2">' +
                  '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
                  getSelectOptionsFromArrayOfObjects(conditionSystemFieldOperators) +
                '</select>' +
              '</div>' +
            '</div>' +

            '<div id="condition-system-field-variable-value-group-0" class="col-12 col-md-4 d-none">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_value + '</label>' +
                '<input class="system-field-variable-value form-control" type="text">' +
              '</div>' +
            '</div>' +

            '<div id="condition-system-field-gender-group-0" class="col-12 col-md-4">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_gender + '</label>' +
                '<select class="system-field-gender form-control select2">' +
                  '<option value="">' + lang.condition_html_title_select + '</option>' +
                  '<option value="male">' + lang.condition_html_gender_male + '</option>' +
                  '<option value="female">' + lang.condition_html_gender_female + '</option>' +
                '</select>' +
              '</div>' +
            '</div>' +

            '<div id="condition-system-field-contact-group-id-group-0" class="col-12 col-md-4 d-none">' +
              '<div class="form-group text-left mt-2">' + 
                '<label>' + lang.condition_html_label_contact_group_id + '</label>' +
                '<select class="system-field-contact-group-id form-control select2"></select>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }
  }

  let custom_field_html = ''

  if (oldData.custom_field_variable && oldData.custom_field_variable.length > 0) {
    custom_field_html += '' +
      '<div class="custom-field-wrapper mt-4">' +
        '<div class="d-flex justify-content-start small pt-4">' +
          '<div>' + lang.condition_html_label_custom_field + '</div> ' + 
          '<div id="custom-field-row-add" class="pl-2"><i class="fas fa-plus-circle text-primary custom-field-row-icon"></i></div>' +
        '</div>'

    oldData.custom_field_variable.forEach((val, idx) => {
      custom_field_html += '' +
        '<div class="row position-relative">' +
          '<div id="condition-custom-field-variable-group-' + idx + '" class="col-12 col-md-4">' +
            '<div class="select2-width-200 form-group text-left mt-2">' + 
              '<label>' + lang.condition_html_label_variable + '</label>' +
              '<select class="custom-field-variable form-control select2">' +
                '<option value="">' + lang.condition_html_title_select + '</option>' +
              '</select>' +
            '</div>' +
          '</div>' +
    
          '<div id="condition-custom-field-operator-group-' + idx + '" class="col-12 col-md-4">' +
            '<div class="form-group text-left mt-2">' + 
              '<label>' + lang.condition_html_label_operator + '</label>' +
              '<select class="custom-field-operator form-control select2">' +
                '<option value="">' + lang.condition_html_title_select + '</option>' +
                getSelectOptionsFromArrayOfObjects(conditionSystemFieldOperators, oldData.custom_field_operator[idx]) +
              '</select>' +
            '</div>' +
          '</div>' +
    
          '<div id="condition-custom-field-variable-value-group-' + idx + '" class="col-12 col-md-4 ' + ('has_value' === oldData.custom_field_operator[idx] ? 'd-none' : 'd-block') + '">' +
            '<div class="form-group text-left mt-2">' + 
              '<label>' + lang.condition_html_label_value + '</label>' +
              '<input class="custom-field-variable-value form-control" type="text" value="' + oldData.custom_field_variable_value[idx] + '">' +
            '</div>' +
          '</div>' +
          '<div class="field-remove-wrapper"><i class="fas fa-minus-circle custom-field-row-icon field-row-remove ' + (0 === idx ? 'd-none' : 'd-inline') + '"></i></div>' +
        '</div>'
    }) 

    custom_field_html += '</div>'
  } else {
    custom_field_html += '' +
      '<div class="custom-field-wrapper mt-4">' +
        '<div class="d-flex justify-content-start small pt-0">' +
          '<div>' + lang.condition_html_label_custom_field + '</div> ' + 
          '<div id="custom-field-row-add" class="pl-2"><i class="fas fa-plus-circle text-primary custom-field-row-icon"></i></div>' +
        '</div>' +

        '<div class="row">' +
          '<div id="condition-custom-field-variable-group-0" class="col-12 col-md-4">' +
            '<div class="select2-width-200 form-group text-left mt-2">' + 
              '<label>' + lang.condition_html_label_variable + '</label>' +
              '<select class="custom-field-variable form-control select2">' +
                '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
              '</select>' +
            '</div>' +
          '</div>' +

          '<div id="condition-custom-field-operator-group-0" class="col-12 col-md-4">' +
            '<div class="form-group text-left mt-2">' + 
              '<label>' + lang.condition_html_label_operator + '</label>' +
              '<select class="custom-field-operator form-control select2">' +
                '<option value="" selected>' + lang.condition_html_title_select + '</option>' +
                getSelectOptionsFromArrayOfObjects(conditionSystemFieldOperators) +
              '</select>' +
            '</div>' +
          '</div>' +

          '<div id="condition-custom-field-variable-value-group-0" class="col-12 col-md-4">' +
            '<div class="form-group text-left mt-2">' + 
              '<label>' + lang.condition_html_label_value + '</label>' +
              '<input class="custom-field-variable-value form-control" type="text">' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  return system_field_html + custom_field_html
}

const getSelectOptions = (optionsArray, defaultValue = null) => {
  let html = ''
  for (const option of optionsArray) {
    if ('object' === typeof option) {
      if (defaultValue) {
        if (Array.isArray(defaultValue)) {
          for (const val of defaultValue) {
            if (val === option.key) {
              html += '<option value="' + option.key + '" selected>' + option.value + '</option>'
            }
          }
        } else {
          if (defaultValue === option.key) {
            html += '<option value="' + option.key + '" selected>' + option.value + '</option>'
          }
        }
      } else {
        html += '<option value="' + option.key + '">' + option.value + '</option>'
      }
    }
  }

  return html
}

const getCustomFieldVariableViaAjax = (callback) => {
  const base_url = window.xitFlowBuilderData.base_url
  const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
  const media_type = instagram_bot_addon ? 'ig' : 'fb'

  $.ajax({
    method: 'GET',
    dataType: 'JSON',
    url: base_url + 'visual_flow_builder/get_custom_field_variable_dropdown/' + media_type,
    success: callback
  })
}

const getLabelViaAjax = (callback) => {
  const page_table_id = window.xitFlowBuilderData.page_table_id
  const base_url = window.xitFlowBuilderData.base_url

  $.ajax({
    method: 'POST',
    dataType: 'JSON',
    url: base_url + 'visual_flow_builder/get_label_dropdown',
    data: { page_table_id },
    success: callback,
  })
}